import clsx from "clsx";
import { splitProps } from "solid-js";
import type { JSX } from "solid-js";

export type InputProps = JSX.InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
};

export function Input(props: InputProps) {
  const [local, rest] = splitProps(props, ["invalid", "class"]);
  return (
    <input
      aria-invalid={local.invalid ? "true" : undefined}
      class={clsx(
        "w-full h-10 rounded-[10px] px-3.5 text-sm bg-[var(--bg-surface)] text-[var(--fg-strong)]",
        "border border-[var(--border-strong)] shadow-[0_1px_2px_rgba(11,18,32,0.04)] transition duration-150",
        "placeholder:text-[var(--fg-subtle)]",
        "hover:border-[var(--fg-subtle)]",
        "focus:outline-none focus:border-[var(--accent-alt)] focus:ring-[3px] focus:ring-[var(--accent-alt-soft)]",
        "aria-[invalid=true]:border-[var(--danger)] aria-[invalid=true]:focus:ring-[var(--danger-soft)]",
        "disabled:bg-[var(--bg-elevated)] disabled:text-[var(--fg-muted)]",
        local.class
      )}
      {...rest}
    />
  );
}

export function Label(props: JSX.LabelHTMLAttributes<HTMLLabelElement>) {
  const [local, rest] = splitProps(props, ["class"]);
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: Generic Label wrapper — the `for` attribute is passed by the caller (see LoginPage.tsx).
    <label
      class={clsx("block text-[13px] font-semibold text-[var(--fg-default)] mb-1.5", local.class)}
      {...rest}
    />
  );
}

export function FieldError(props: { children: JSX.Element }) {
  return (
    <p role="alert" class="mt-1.5 text-xs font-medium text-[var(--danger)]">
      {props.children}
    </p>
  );
}
